import { CalendarDays, Heading1, Image, Minus, MousePointerClick, MoveVertical, Type } from 'lucide-react';
import type { Blocco, TipoBlocco } from '@email/types.ts';

export interface VoceBlocco {
  tipo: TipoBlocco;
  etichetta: string;
  descrizione: string;
  icona: typeof Type;
}

/**
 * I blocchi che si possono mettere dentro una email, nell'ordine in cui
 * compaiono nel pannello. Vive qui e non dentro l'editor perche' lo leggono
 * in due: il pannello che li mostra e la tela che li crea.
 */
export const BLOCCHI_DISPONIBILI: VoceBlocco[] = [
  { tipo: 'titolo', etichetta: 'Titolo', descrizione: 'Una riga in grande', icona: Heading1 },
  { tipo: 'testo', etichetta: 'Testo', descrizione: 'Uno o piu\' paragrafi', icona: Type },
  { tipo: 'immagine', etichetta: 'Immagine', descrizione: 'Una foto o il logo', icona: Image },
  { tipo: 'bottone', etichetta: 'Bottone', descrizione: 'Un invito a cliccare', icona: MousePointerClick },
  { tipo: 'separatore', etichetta: 'Riga', descrizione: 'Divide due parti', icona: Minus },
  { tipo: 'spazio', etichetta: 'Spazio', descrizione: 'Aria fra i blocchi', icona: MoveVertical },
  {
    tipo: 'percorso_evento',
    etichetta: 'Percorso dell\'evento',
    descrizione: 'Gli incontri assegnati a chi riceve',
    icona: CalendarDays,
  },
];

/** Prefisso degli identificativi del pannello: serve a distinguere un blocco
 *  appena nato, che va inserito, da uno gia' nella email, che va spostato. */
export const PREFISSO_PALETTE = 'palette:';

export function tipoDaIdPalette(id: string): TipoBlocco | null {
  if (!id.startsWith(PREFISSO_PALETTE)) return null;
  const tipo = id.slice(PREFISSO_PALETTE.length);
  return BLOCCHI_DISPONIBILI.some((v) => v.tipo === tipo) ? (tipo as TipoBlocco) : null;
}

export function bloccoNuovo(tipo: TipoBlocco): Blocco {
  const id = crypto.randomUUID();
  switch (tipo) {
    case 'titolo':
      return { id, tipo: 'titolo', testo: '', livello: 2, allineamento: 'sinistra' };
    case 'testo':
      return { id, tipo: 'testo', paragrafi: [], allineamento: 'sinistra' };
    case 'immagine':
      return { id, tipo: 'immagine', url: '', alt: '', larghezza: 'piena' };
    case 'bottone':
      return { id, tipo: 'bottone', testo: '', url: '', allineamento: 'centro' };
    case 'separatore':
      return { id, tipo: 'separatore' };
    case 'spazio':
      return { id, tipo: 'spazio', altezza: 24 };
    case 'percorso_evento':
      // L'evento si sceglie nella scheda del blocco; le righe le mette il
      // motore al momento dell'invio, persona per persona.
      return { id, tipo: 'percorso_evento', evento_id: '' };
  }
}
